// extracted by mini-css-extract-plugin
export var backButton = "header-module--backButton--a0f40";
export var darkText = "header-module--darkText--d8035";
export var description = "header-module--description--d142d";
export var header = "header-module--header--e1d40";
export var subtitle = "header-module--subtitle--2dc1e";
export var title = "header-module--title--8177a";
export var uppercase = "header-module--uppercase--da6b8";